export const POINTS_TRANSLATION_KEY = 'crowns';
